module.exports = __webpack_public_path__ + "img/flip-icon.3246ec89.svg";